import FlexContainerLayout from "components/atoms/FlexContainerLayout";
import SchemaModelCreateOptions from "components/molecules/SchemaModelCreateOptions";
import SchemaModelCreateFromFile from "components/organisms/SchemaModelCreateFromFile";
import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import SchemaModelClone from "./SchemaModelClone";

class SchemaModelCreateAutomation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            createOption: "CREATE_FROM_FILE",
        };
    }

    componentWillMount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {}

    onOptionSelected = (option) => {
        if (option === "CREATE_MANUALLY") {
            this.props.onManuallyCreateSchema && this.props.onManuallyCreateSchema();
        } else if (option === "CREATE_FROM_SYSTEM_CONNECTION") {
            this.props.onCreateFromSystemConnection && this.props.onCreateFromSystemConnection();
        } else {
            this.setState({
                createOption: option,
            });
        }
    };

    getOptionComponent = () => {
        switch (this.state.createOption) {
            case "CREATE_FROM_FILE":
                return (
                    <SchemaModelCreateFromFile
                        onCreateSchemaModel={this.props.onCreateSchemaModel}
                        onUploadFile={this.props.onUploadSchemaDefinitionFile}
                        uploadFileResult={this.props.uploadSchemaModelDefinitionResult}
                        uploadedFile={this.props.schemaModelDefinitionFile}
                        getParsedSchemaDefinition={this.props.getParsedSchemaDefinition}
                        getParsedSchemaDefinitionResult={this.props.getParsedSchemaDefinitionResult}
                        schemaDefinition={this.props.schemaDefinition}
                        onManageParsedSchemaModel={this.props.onManageParsedSchemaModel}
                        onCancelManageParsedSchemaModel={this.props.onCancelManageParsedSchemaModel}
                        manageParsedSchemaModelCancelled={this.props.manageParsedSchemaModelCancelled}
                        getSchemaProfile={this.props.getSchemaProfile}
                        getSchemaProfileResult={this.props.getSchemaProfileResult}
                        schemaProfile={this.props.schemaProfile}
                        schemaProfileUnsupported={this.props.schemaProfileUnsupported}
                        onSchemaProfileReady={this.props.onSchemaProfileReady}
                    ></SchemaModelCreateFromFile>
                );
            case "CLONE_EXISTING_SCHEMA":
                return <SchemaModelClone tenant={this.props.tenant} businessArea={this.props.businessArea}></SchemaModelClone>;
            default:
                return <></>;
        }
    };

    render() {
        return (
            <FlexContainerLayout
                showHeader={true}
                header={<SchemaModelCreateOptions selectedOption={this.state.createOption} onOptionSelected={this.onOptionSelected}></SchemaModelCreateOptions>}
                contentClassName="size-full"
            >
                {this.getOptionComponent()}
            </FlexContainerLayout>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SchemaModelCreateAutomation));
